import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  paymentData: {
    serviceCategoryName: '',
    price: null,
    doctorName: '',
    doctorFamil: '',
    serviceCategoryId: null,
    serviceDoctorId: null,
    patientName: '',
    patientId: null,
    dateSelected: '',
    timeSelected: '',
    num: null,
    doctorId: null,
    sortOrder: null
  },
  walletBalance: 0,
  isPaymentSuccessful: false,
  isPageLocked: false,
  isLoading: false,
  error: null,
  authority: '',
  isTurnValid: true
};

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    setPaymentData: (state, action) => {
      state.paymentData = { ...state.paymentData, ...action.payload };
    },
    setWalletBalance: (state, action) => {
      state.walletBalance = action.payload;
    },
    setPaymentSuccessful: (state, action) => {
      state.isPaymentSuccessful = action.payload;
    },
    setPageLocked: (state, action) => {
      state.isPageLocked = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setAuthority: (state, action) => {
      state.authority = action.payload;
    },
    setTurnValid: (state, action) => {
      state.isTurnValid = action.payload;
    },
    resetPaymentState: (state) => {
      return initialState;
    }
  }
});

export const {
  setPaymentData,
  setWalletBalance,
  setPaymentSuccessful,
  setPageLocked,
  setLoading,
  setError,
  setAuthority,
  setTurnValid,
  resetPaymentState
} = paymentSlice.actions;

export default paymentSlice.reducer; 